<template>
  <form novalidate>
    <h4 class="h4 text--bold text--uppercase">Sobre el ataque que se está atendiendo</h4>
    <form-group :error="errors.has('fecha-ataque')">
      <datetime
        :disabled="!editando"
        v-model="form.fechaAtaque"
        v-validate="'required'"
        :use12-hour="true"
        input-class="form__input"
        name="fecha-ataque"
        value-zone="local"
        type="date"/>
      <label class="form__label form__label--required">40. En qué fecha se dio el ataque?</label>
    </form-group>

    <form-group :error="errors.has('momento-ataque') && submitted">
      <label class="form__label form__label--required">41. Momento del ataque</label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.momentoAtaque"
        id="ataque-dia"
        name="momento-ataque"
        v-validate="'required'"
        value="De día">
        <label class="form__label" for="ataque-dia">De día</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.momentoAtaque"
        id="momento-noche"
        name="momento-ataque"
        v-validate="'required'"
        value="De noche">
        <label class="form__label" for="momento-noche">De noche</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.momentoAtaque"
        id="momento-nsnr"
        name="momento-ataque"
        v-validate="'required'"
        value="NS/NR">
        <label class="form__label" for="momento-nsnr">NS/NR</label>
      </div>
    </form-group>

    <form-group :error="errors.has('especie-atacada') && submitted">
      <label class="form__label form__label--required">42. Especie atacada</label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.especieAtacada"
        id="res-atacado"
        name="especie-atacada"
        v-validate="'required'"
        value="Res">
        <label class="form__label" for="res-atacado">Res</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.especieAtacada"
        id="caballo-atacado"
        name="especie-atacada"
        v-validate="'required'"
        value="Caballo">
        <label class="form__label" for="caballo-atacado">Caballo</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.especieAtacada"
        id="cabra-atacada"
        name="especie-atacada"
        v-validate="'required'"
        value="Cabra">
        <label class="form__label" for="cabra-atacada">Cabra</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.especieAtacada"
        id="oveja-atacada"
        name="especie-atacada"
        v-validate="'required'"
        value="Oveja">
        <label class="form__label" for="oveja-atacada">Oveja</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.especieAtacada"
        id="bufalo-atacado"
        name="especie-atacada"
        v-validate="'required'"
        value="Búfalo">
        <label class="form__label" for="bufalo-atacado">Búfalo</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.especieAtacada"
        id="cerdo-atacado"
        name="especie-atacada"
        v-validate="'required'"
        value="Cerdo">
        <label class="form__label" for="cerdo-atacado">Cerdo</label>
      </div>
    </form-group>

    <form-group :error="errors.has('raza-animal-atacado') && submitted">
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="text"
      class="form__input"
      name="raza-animal-atacado"
      required
      v-validate="'required'"
      v-model="form.razaAnimalAtacado">
      <label class="form__label">43. Raza del animal atacado</label>
    </form-group>

    <form-group :error="errors.has('edad-animal-atacado') && submitted">
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="number"
      class="form__input"
      name="edad-animal-atacado"
      required
      v-validate="'required'"
      v-model.number="form.edadAnimalAtacado">
      <label class="form__label form__label--required">44. Edad del animal atacado</label>
      <form-group class="my-0" :error="errors.has('unidad-edad-animal') && submitted">
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.unidadEdadAnimal"
          id="edadAnimalAnos"
          name="unidad-edad-animal"
          v-validate="'required'"
          value="años">
          <label class="form__label" for="edadAnimalAnos">Años</label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.unidadEdadAnimal"
          id="edadAnimalMeses"
          name="unidad-edad-animal"
          v-validate="'required'"
          value="meses">
          <label class="form__label" for="edadAnimalMeses">Meses</label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.unidadEdadAnimal"
          id="edadAnimalDias"
          name="unidad-edad-animal"
          v-validate="'required'"
          value="días">
          <label class="form__label" for="edadAnimalDias">Días</label>
        </div>
      </form-group>
    </form-group>

    <form-group :error="errors.has('sexo-animal-atacado') && submitted">
      <label class="form__label form__label--required">45. Sexo del animal atacado</label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.sexoAnimalAtacado"
        id="machosexoAnimalAtacado"
        name="sexo-animal-atacado"
        v-validate="'required'"
        value="Macho">
        <label class="form__label" for="machosexoAnimalAtacado">Macho</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.sexoAnimalAtacado"
        id="hembrasexoAnimalAtacado"
        name="sexo-animal-atacado"
        v-validate="'required'"
        value="Hembra">
        <label class="form__label" for="hembrasexoAnimalAtacado">
          Hembra
        </label>
      </div>
    </form-group>

    <form-group :error="errors.has('peso-animal-atacado') && submitted">
      <label class="form__label form__label--required">
        46. Peso en kilogramos del animal atacado
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="menos25kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="Menos de 25kg">
        <label class="form__label" for="menos25kgpesoAnimalAtacado">Menos de 25kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="50kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="50kg">
        <label class="form__label" for="50kgpesoAnimalAtacado">50kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="75kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="75kg">
        <label class="form__label" for="75kgpesoAnimalAtacado">75kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="100kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="100kg">
        <label class="form__label" for="100kgpesoAnimalAtacado">100kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="125kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="125kg">
        <label class="form__label" for="125kgpesoAnimalAtacado">125kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="150kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="150kg">
        <label class="form__label" for="150kgpesoAnimalAtacado">150kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="175kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="175kg">
        <label class="form__label" for="175kgpesoAnimalAtacado">175kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="200kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="200kg">
        <label class="form__label" for="200kgpesoAnimalAtacado">200kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="225kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="225kg">
        <label class="form__label" for="225kgpesoAnimalAtacado">225kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="250kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="250kg">
        <label class="form__label" for="250kgpesoAnimalAtacado">250kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="275kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="275kg">
        <label class="form__label" for="275kgpesoAnimalAtacado">275kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="300kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="300kg">
        <label class="form__label" for="300kgpesoAnimalAtacado">300kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="325kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="325kg">
        <label class="form__label" for="325kgpesoAnimalAtacado">325kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="350kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="350kg">
        <label class="form__label" for="350kgpesoAnimalAtacado">350kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="375kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="375kg">
        <label class="form__label" for="375kgpesoAnimalAtacado">375kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="mayor400kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="Mayor a 400kg">
        <label class="form__label" for="mayor400kgpesoAnimalAtacado">Mayor a 400kg</label>
      </div>
      <div class="identado" v-if="form.pesoAnimalAtacado === 'Mayor a 400kg'">
        <form-group :error="errors.has('otro-peso-animal-atacado') && submitted">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="number"
          class="form__input"
          v-model.number="form.otroPesoAnimalAtacado"
          name="otro-peso-animal-atacado"
          required
          v-validate="'required'">
          <label class="form__label">
            ¿Aproximadamente cuántos kg?
          </label>
        </form-group>
      </div>
    </form-group>

    <form-group :error="errors.has('salud-atacado') && submitted">
      <label class="form__label form__label--required">
        47. Estado de salud/condición del animal atacado
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.saludAnimalAtacado"
        id="sanokgsaludAnimalAtacado"
        name="salud-atacado"
        v-validate="'required'"
        value="Sano">
        <label class="form__label" for="sanokgsaludAnimalAtacado">Sano</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.saludAnimalAtacado"
        id="enfermosaludAnimalAtacado"
        name="salud-atacado"
        v-validate="'required'"
        value="Enfermo">
        <label class="form__label" for="enfermosaludAnimalAtacado">Enfermo</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.saludAnimalAtacado"
        id="lesionadosaludAnimalAtacado"
        name="salud-atacado"
        v-validate="'required'"
        value="Lesionado">
        <label class="form__label" for="lesionadosaludAnimalAtacado">Lesionado</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.saludAnimalAtacado"
        id="preñadasaludAnimalAtacado"
        name="salud-atacado"
        v-validate="'required'"
        value="Preñada">
        <label class="form__label" for="preñadasaludAnimalAtacado">Preñada</label>
      </div>
    </form-group>

    <form-group :error="errors.has('resultado-ataque') && submitted">
      <label class="form__label form__label--required">
        48. Resultado del ataque
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.resultadoAnimalAtacado"
        id="1resultadoAnimalAtacado"
        name="resultado-ataque"
        v-validate="{ required: !form.resultadoAnimalAtacadoCheckOtro }"
        value="Herido y luego murió">
        <label class="form__label" for="1resultadoAnimalAtacado">Herido y luego murió</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.resultadoAnimalAtacado"
        id="2resultadoAnimalAtacado"
        name="resultado-ataque"
        v-validate="{ required: !form.resultadoAnimalAtacadoCheckOtro }"
        value="Herido pero sigue vivo">
        <label class="form__label" for="2resultadoAnimalAtacado">Herido pero sigue vivo</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.resultadoAnimalAtacado"
        id="3resultadoAnimalAtacado"
        name="resultado-ataque"
        v-validate="{ required: !form.resultadoAnimalAtacadoCheckOtro }"
        value="Muerto pero no comió">
        <label class="form__label" for="3resultadoAnimalAtacado">Muerto pero no comió</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.resultadoAnimalAtacado"
        id="4resultadoAnimalAtacado"
        name="resultado-ataque"
        v-validate="{ required: !form.resultadoAnimalAtacadoCheckOtro }"
        value="Muerto y comido">
        <label class="form__label" for="4resultadoAnimalAtacado">Muerto y comido</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.resultadoAnimalAtacadoCheckOtro"
        id="5resultadoAnimalAtacado">
        <label class="form__label" for="5resultadoAnimalAtacado">
          Otro / Comentarios adicionales
        </label>
      </div>
    </form-group>

    <form-group
    v-if="form.resultadoAnimalAtacado === 'Muerto y comido'"
    :error="errors.has('resultado-ataque-parte') && submitted">
      <label class="form__label form__label--required">Seleccione las partes atacadas</label>
      <div class="contenedor-partes-vaca">
        <div>
          <div class="checkbox checkbox--azul">
            <input
            :disabled="deshabilitarPartes || !editando"
            type="checkbox"
            v-model="form.resultadoAnimalAtacadoPartes"
            id="vaca-parte1"
            name="resultado-ataque-parte"
            v-validate="'required'"
            value="(1) Hocico">
            <label class="form__label" for="vaca-parte1">(1) Hocico</label>
          </div>
          <div class="checkbox checkbox--azul">
            <input
            :disabled="deshabilitarPartes || !editando"
            type="checkbox"
            v-model="form.resultadoAnimalAtacadoPartes"
            id="vaca-parte2"
            name="resultado-ataque-parte"
            v-validate="'required'"
            value="(2) Cara / Frente">
            <label class="form__label" for="vaca-parte2">(2) Cara / Frente</label>
          </div>
          <div class="checkbox checkbox--azul">
            <input
            :disabled="deshabilitarPartes || !editando"
            type="checkbox"
            v-model="form.resultadoAnimalAtacadoPartes"
            id="vaca-parte3"
            name="resultado-ataque-parte"
            v-validate="'required'"
            value="(3) Papada">
            <label class="form__label" for="vaca-parte3">(3) Papada</label>
          </div>
          <div class="checkbox checkbox--azul">
            <input
            :disabled="deshabilitarPartes || !editando"
            type="checkbox"
            v-model="form.resultadoAnimalAtacadoPartes"
            id="vaca-parte4"
            name="resultado-ataque-parte"
            v-validate="'required'"
            value="(4) Orejas">
            <label class="form__label" for="vaca-parte4">(4) Orejas</label>
          </div>
          <div class="checkbox checkbox--azul">
            <input
            :disabled="deshabilitarPartes || !editando"
            type="checkbox"
            v-model="form.resultadoAnimalAtacadoPartes"
            id="vaca-parte5"
            name="resultado-ataque-parte"
            v-validate="'required'"
            value="(5) Nuca / Giba">
            <label class="form__label" for="vaca-parte5">(5) Nuca / Giba</label>
          </div>
          <div class="checkbox checkbox--azul">
            <input
            :disabled="deshabilitarPartes || !editando"
            type="checkbox"
            v-model="form.resultadoAnimalAtacadoPartes"
            id="vaca-parte6"
            name="resultado-ataque-parte"
            v-validate="'required'"
            value="(6) Cuello / Pescuezo">
            <label class="form__label" for="vaca-parte6">(6) Cuello / Pescuezo</label>
          </div>
          <div class="checkbox checkbox--azul">
            <input
            :disabled="deshabilitarPartes || !editando"
            type="checkbox"
            v-model="form.resultadoAnimalAtacadoPartes"
            id="vaca-parte7"
            name="resultado-ataque-parte"
            v-validate="'required'"
            value="(7) Espalda / Lomo alto">
            <label class="form__label" for="vaca-parte7">(7) Espalda / Lomo alto</label>
          </div>
          <div class="checkbox checkbox--azul">
            <input
            :disabled="deshabilitarPartes || !editando"
            type="checkbox"
            v-model="form.resultadoAnimalAtacadoPartes"
            id="vaca-parte8"
            name="resultado-ataque-parte"
            v-validate="'required'"
            value="(8) Pecho">
            <label class="form__label" for="vaca-parte8">(8) Pecho</label>
          </div>
          <div class="checkbox checkbox--azul">
            <input
            :disabled="deshabilitarPartes || !editando"
            type="checkbox"
            v-model="form.resultadoAnimalAtacadoPartes"
            id="vaca-parte9"
            name="resultado-ataque-parte"
            v-validate="'required'"
            value="(9) Paleta / Costilla / Espaldilla / Costillar">
            <label class="form__label" for="vaca-parte9">(9) Paleta / Costilla / Espaldilla /
              Costillar</label>
          </div>
          <div class="checkbox checkbox--azul">
            <input
            :disabled="deshabilitarPartes || !editando"
            type="checkbox"
            v-model="form.resultadoAnimalAtacadoPartes"
            id="vaca-parte10"
            name="resultado-ataque-parte"
            v-validate="'required'"
            value="(10) Lomo / Lomo bajo">
            <label class="form__label" for="vaca-parte10">(10) Lomo / Lomo bajo</label>
          </div>
        </div>
        <div>
          <div class="checkbox checkbox--azul">
            <input
            :disabled="deshabilitarPartes || !editando"
            type="checkbox"
            v-model="form.resultadoAnimalAtacadoPartes"
            id="vaca-parte11"
            name="resultado-ataque-parte"
            v-validate="'required'"
            value="(11) Visceras / Abdomen / Vientre / Falda">
            <label class="form__label" for="vaca-parte11">(11) Visceras / Abdomen / Vientre / Falda
            </label>
          </div>
          <div class="checkbox checkbox--azul">
            <input
            :disabled="deshabilitarPartes || !editando"
            type="checkbox"
            v-model="form.resultadoAnimalAtacadoPartes"
            id="vaca-parte12"
            name="resultado-ataque-parte"
            v-validate="'required'"
            value="(12) Nalga / Cadera">
            <label class="form__label" for="vaca-parte12">(12) Nalga / Cadera</label>
          </div>
          <div class="checkbox checkbox--azul">
            <input
            :disabled="deshabilitarPartes || !editando"
            type="checkbox"
            v-model="form.resultadoAnimalAtacadoPartes"
            id="vaca-parte13"
            name="resultado-ataque-parte"
            v-validate="'required'"
            value="(13) Pierna / Babilla / Cuarto trasero">
            <label class="form__label" for="vaca-parte13">(13) Pierna / Babilla / Cuarto trasero
            </label>
          </div>
          <div class="checkbox checkbox--azul">
            <input
            :disabled="deshabilitarPartes || !editando"
            type="checkbox"
            v-model="form.resultadoAnimalAtacadoPartes"
            id="vaca-parte14"
            name="resultado-ataque-parte"
            v-validate="'required'"
            value="(14) Cola / Rabo">
            <label class="form__label" for="vaca-parte14">(14) Cola / Rabo</label>
          </div>
          <div class="checkbox checkbox--azul">
            <input
            :disabled="deshabilitarPartes || !editando"
            type="checkbox"
            v-model="form.resultadoAnimalAtacadoPartes"
            id="vaca-parte15"
            name="resultado-ataque-parte"
            v-validate="'required'"
            value="(15) Ubre / Tetas / Testículos">
            <label class="form__label" for="vaca-parte15">(15) Ubre / Tetas / Testículos</label>
          </div>
          <div class="checkbox checkbox--azul">
            <input
            :disabled="deshabilitarPartes || !editando"
            type="checkbox"
            v-model="form.resultadoAnimalAtacadoPartes"
            id="vaca-parte16"
            name="resultado-ataque-parte"
            v-validate="'required'"
            value="(16) Pata delantera">
            <label class="form__label" for="vaca-parte16">(16) Pata delantera</label>
          </div>
          <div class="checkbox checkbox--azul">
            <input
            :disabled="deshabilitarPartes || !editando"
            type="checkbox"
            v-model="form.resultadoAnimalAtacadoPartes"
            id="vaca-parte17"
            name="resultado-ataque-parte"
            v-validate="'required'"
            value="(17) PPata trasera">
            <label class="form__label" for="vaca-parte17">(17) Pata trasera</label>
          </div>
          <div class="checkbox checkbox--azul">
            <input
            :disabled="deshabilitarPartes || !editando"
            type="checkbox"
            v-model="form.resultadoAnimalAtacadoPartes"
            id="vaca-parte18"
            name="resultado-ataque-parte"
            v-validate="'required'"
            value="(18) Pezuña delantera">
            <label class="form__label" for="vaca-parte18">(18) Pezuña delantera</label>
          </div>
          <div class="checkbox checkbox--azul">
            <input
            :disabled="deshabilitarPartes || !editando"
            type="checkbox"
            v-model="form.resultadoAnimalAtacadoPartes"
            id="vaca-parte19"
            name="resultado-ataque-parte"
            v-validate="'required'"
            value="(19) Pezuña trasera">
            <label class="form__label" for="vaca-parte19">(19) Pezuña trasera</label>
          </div>
          <div class="checkbox checkbox--azul">
            <input
            :disabled="!editando"
            type="checkbox"
            v-model="form.resultadoAnimalAtacadoPartes"
            id="vaca-todo"
            name="resultado-ataque-parte"
            v-validate="'required'"
            value="Todo"
            @change="onAnimalPartesTodoCheck"
            >
            <label class="form__label" for="vaca-todo">Todo</label>
          </div>
        </div>
      </div>
      <img src="/partes-vaca-numeradas.jpg" width="100%">
    </form-group>

    <div class="identado">
      <form-group
      v-if="form.resultadoAnimalAtacadoCheckOtro"
      :error="errors.has('otra-resultado-ataque') && submitted">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        v-model="form.resultadoAnimalAtacadoOtro"
        name="otra-resultado-ataque"
        required
        v-validate="'required'">
        <label class="form__label">
          Especifique:
        </label>
      </form-group>

      <form-group
      v-if="form.resultadoAnimalAtacado === 'Herido y luego murió' ||
      form.resultadoAnimalAtacado === 'Herido pero sigue vivo' ||
      form.resultadoAnimalAtacado === 'Muerto pero no comió'"
      :error="errors.has('heridas-resultado-animal-atacado') && submitted">
        <textarea
        data-vv-validate-on="blur"
        v-if="editando"
        type="text"
        class="form__input"
        v-model="form.resultadoAnimalAtacadoHeridas"
        name="heridas-resultado-animal-atacado"
        required
        v-validate="'required'"/>
        <p v-else class="text">{{form.resultadoAnimalAtacadoHeridas}}</p>
        <label class="form__label">
          Describa las heridas y donde las tenía? (ej. rasguños en el lomo o colmillazos en la nuca)
        </label>
      </form-group>

      <form-group :error="errors.has('utilizoMedicamento') && submitted"
      v-if="form.resultadoAnimalAtacado === 'Herido pero sigue vivo'">
        <label class="form__label form__label--required">
          ¿Utilizó algún medicamento o algo para curar?
        </label>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.utilizoMedicamento"
          id="siutilizoMedicamento"
          name="utilizoMedicamento"
          v-validate="'required'"
          :value="true">
          <label class="form__label" for="siutilizoMedicamento">
            Si
          </label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.utilizoMedicamento"
          id="noutilizoMedicamento"
          name="utilizoMedicamento"
          v-validate="'required'"
          :value="false">
          <label class="form__label" for="noutilizoMedicamento">
            No
          </label>
        </div>
      </form-group>

      <form-group :error="errors.has('valor-medicamento') && submitted"
      v-if="form.utilizoMedicamento && form.resultadoAnimalAtacado === 'Herido pero sigue vivo'">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="number"
        class="form__input"
        v-model.number="form.valorMedicamento"
        name="valor-medicamento"
        required
        v-validate="'required'">
        <label class="form__label">
          Valor aproximado de los medicamentos que compró
        </label>
      </form-group>

      <form-group :error="errors.has('medicamentos-utilizados') && submitted"
      v-if="form.utilizoMedicamento && form.resultadoAnimalAtacado === 'Herido pero sigue vivo'">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        v-model="form.medicamentoUtilizado"
        name="medicamentos-utilizados"
        required
        v-validate="'required'">
        <label class="form__label">
          ¿Cuáles medicamentos utilizó?
        </label>
      </form-group>
    </div>

    <form-group>
      <label class="form__label form__label--opcional">
        49. Solo si el animal atacado murió, este estaba cubierto o semicubierto con vegetación
        (como si le pusieron vegetación encima intencionadamente para esconderlo)
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.estabaAnimalCubierto"
        id="si-cubierto"
        name="estaba-cubierto"
        :value="true">
        <label class="form__label" for="si-cubierto">Sí</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.estabaAnimalCubierto"
        id="no-cubierto"
        name="estaba-cubierto"
        :value="false">
        <label class="form__label" for="no-cubierto">No</label>
      </div>
    </form-group>

    <form-group>
      <label class="form__label form__label--opcional">
        50. Solo si el animal atacado murió, cree usted que el depredador arrastró la presa
        (la mató en un punto X y la arrastró a un punto Y)
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.presaFueArrastrada"
        id="si-arrastrado"
        name="presa-arrastrada"
        value="Si">
        <label class="form__label" for="si-arrastrado">Sí</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.presaFueArrastrada"
        id="no-arrastrado"
        name="presa-arrastrada"
        value="No">
        <label class="form__label" for="no-arrastrado">No</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.presaFueArrastrada"
        id="na-arrastrado"
        name="presa-arrastrada"
        value="No aplica">
        <label class="form__label" for="na-arrastrado">No aplica</label>
      </div>
    </form-group>

    <form-group class="identado"
    v-if="form.presaFueArrastrada === 'Si'"
    :error="errors.has('distancia-arrastre') && submitted">
      <label class="form__label form__label--required">¿Cuántos metros?</label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distanciaArrastrada"
        id="distancia25menos"
        name="distancia-arrastre"
        v-validate="'required'"
        value="Menos de 25m">
        <label class="form__label" for="distancia25menos">Menos de 25m</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distanciaArrastrada"
        id="distancia25"
        name="distancia-arrastre"
        v-validate="'required'"
        value="25m">
        <label class="form__label" for="distancia25">25m</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distanciaArrastrada"
        id="distancia50"
        name="distancia-arrastre"
        v-validate="'required'"
        value="50m">
        <label class="form__label" for="distancia50">50m</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distanciaArrastrada"
        id="distancia75"
        name="distancia-arrastre"
        v-validate="'required'"
        value="75m">
        <label class="form__label" for="distancia75">75m</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distanciaArrastrada"
        id="distancia100"
        name="distancia-arrastre"
        v-validate="'required'"
        value="100m">
        <label class="form__label" for="distancia100">100m</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distanciaArrastrada"
        id="distancia125"
        name="distancia-arrastre"
        v-validate="'required'"
        value="125m">
        <label class="form__label" for="distancia125">125m</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distanciaArrastrada"
        id="distancia150"
        name="distancia-arrastre"
        v-validate="'required'"
        value="150m">
        <label class="form__label" for="distancia150">150m</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distanciaArrastrada"
        id="distancia175"
        name="distancia-arrastre"
        v-validate="'required'"
        value="175m">
        <label class="form__label" for="distancia175">175m</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distanciaArrastrada"
        id="distancia200"
        name="distancia-arrastre"
        v-validate="'required'"
        value="200m">
        <label class="form__label" for="distancia200">200m</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distanciaArrastrada"
        id="distancia225"
        name="distancia-arrastre"
        v-validate="'required'"
        value="225m">
        <label class="form__label" for="distancia225">225m</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distanciaArrastrada"
        id="distancia250"
        name="distancia-arrastre"
        v-validate="'required'"
        value="250m">
        <label class="form__label" for="distancia250">250m</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distanciaArrastrada"
        id="distancia275"
        name="distancia-arrastre"
        v-validate="'required'"
        value="275m">
        <label class="form__label" for="distancia275">275m</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distanciaArrastrada"
        id="distancia300"
        name="distancia-arrastre"
        v-validate="'required'"
        value="300m">
        <label class="form__label" for="distancia300">300m</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distanciaArrastrada"
        id="distancia300mas"
        name="distancia-arrastre"
        v-validate="'required'"
        value="Más de 300m">
        <label class="form__label" for="distancia300mas">Más de 300m</label>
      </div>
    </form-group>

    <form-group :error="errors.has('valor-animal-atacado') && submitted">
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="number"
      class="form__input"
      name="valor-animal-atacado"
      required
      v-validate="'required'"
      v-model.number="form.valorAnimalAtacado">
      <label class="form__label">51. Valor aproximado en colones del animal atacado?</label>
    </form-group>

    <form-group :error="errors.has('distHumanos') && submitted">
      <label class="form__label form__label--required">
        52. Distancia en metros entre el sitio del ataque y la casa o
        infraestructura habitada por humanos más cercana
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="menos50mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="Menos de 50m">
        <label class="form__label" for="menos50mdistHumanos">
          Menos de 50m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="50mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="50m">
        <label class="form__label" for="50mdistHumanos">
          50m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="100mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="100m">
        <label class="form__label" for="100mdistHumanos">
          100m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="150mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="150m">
        <label class="form__label" for="150mdistHumanos">
          150m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="200mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="200m">
        <label class="form__label" for="200mdistHumanos">
          200m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="250mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="250m">
        <label class="form__label" for="250mdistHumanos">
          250m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="300mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="300m">
        <label class="form__label" for="300mdistHumanos">
          300m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="350mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="350m">
        <label class="form__label" for="350mdistHumanos">
          350m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="400mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="400m">
        <label class="form__label" for="400mdistHumanos">
          400m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="450mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="450m">
        <label class="form__label" for="450mdistHumanos">
          450m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="500mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="500m">
        <label class="form__label" for="500mdistHumanos">
          500m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="550mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="550m">
        <label class="form__label" for="550mdistHumanos">
          550m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="600mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="600m">
        <label class="form__label" for="600mdistHumanos">
          600m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="650mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="650m">
        <label class="form__label" for="650mdistHumanos">
          650m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="700mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="700m">
        <label class="form__label" for="700mdistHumanos">
          700m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="750mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="750m">
        <label class="form__label" for="750mdistHumanos">
          750m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="800mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="800m">
        <label class="form__label" for="800mdistHumanos">
          800m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="850mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="850m">
        <label class="form__label" for="850mdistHumanos">
          850m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="900mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="900m">
        <label class="form__label" for="900mdistHumanos">
          900m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="950mdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="950m">
        <label class="form__label" for="950mdistHumanos">
          950m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="1kdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="1km">
        <label class="form__label" for="1kdistHumanos">
          1km
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distHumanos"
        id="mas1kdistHumanos"
        name="distHumanos"
        v-validate="'required'"
        value="Más de 1km">
        <label class="form__label" for="mas1kdistHumanos">
          Más de 1km
        </label>
      </div>
    </form-group>

    <form-group :error="errors.has('distBosque') && submitted">
      <label class="form__label form__label--required">
        53. Distancia en metros entre el sitio del ataque y el bosque más cercano
        (parche de montaña o "monte")
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="menos50mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="Menos de 50m">
        <label class="form__label" for="menos50mdistBosque">
          Menos de 50m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="50mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="50m">
        <label class="form__label" for="50mdistBosque">
          50m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="100mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="100m">
        <label class="form__label" for="100mdistBosque">
          100m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="150mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="150m">
        <label class="form__label" for="150mdistBosque">
          150m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="200mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="200m">
        <label class="form__label" for="200mdistBosque">
          200m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="250mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="250m">
        <label class="form__label" for="250mdistBosque">
          250m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="300mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="300m">
        <label class="form__label" for="300mdistBosque">
          300m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="350mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="350m">
        <label class="form__label" for="350mdistBosque">
          350m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="400mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="400m">
        <label class="form__label" for="400mdistBosque">
          400m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="450mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="450m">
        <label class="form__label" for="450mdistBosque">
          450m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="500mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="500m">
        <label class="form__label" for="500mdistBosque">
          500m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="550mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="550m">
        <label class="form__label" for="550mdistBosque">
          550m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="600mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="600m">
        <label class="form__label" for="600mdistBosque">
          600m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="650mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="650m">
        <label class="form__label" for="650mdistBosque">
          650m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="700mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="700m">
        <label class="form__label" for="700mdistBosque">
          700m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="750mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="750m">
        <label class="form__label" for="750mdistBosque">
          750m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="800mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="800m">
        <label class="form__label" for="800mdistBosque">
          800m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="850mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="850m">
        <label class="form__label" for="850mdistBosque">
          850m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="900mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="900m">
        <label class="form__label" for="900mdistBosque">
          900m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="950mdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="950m">
        <label class="form__label" for="950mdistBosque">
          950m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="1kdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="1km">
        <label class="form__label" for="1kdistBosque">
          1km
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distBosque"
        id="mas1kdistBosque"
        name="distBosque"
        v-validate="'required'"
        value="Más de 1km">
        <label class="form__label" for="mas1kdistBosque">
          Más de 1km
        </label>
      </div>
    </form-group>

    <form-group :error="errors.has('distCuerpoAgua') && submitted">
      <label class="form__label form__label--required">
        54. Distancia en metros entre el sitio del ataque y el cuerpo de agua más cercano
        (río, riachuelo, quebrada, canal, etc)
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="menos50mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="Menos de 50m">
        <label class="form__label" for="menos50mdistCuerpoAgua">
          Menos de 50m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="50mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="50m">
        <label class="form__label" for="50mdistCuerpoAgua">
          50m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="100mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="100m">
        <label class="form__label" for="100mdistCuerpoAgua">
          100m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="150mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="150m">
        <label class="form__label" for="150mdistCuerpoAgua">
          150m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="200mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="200m">
        <label class="form__label" for="200mdistCuerpoAgua">
          200m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="250mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="250m">
        <label class="form__label" for="250mdistCuerpoAgua">
          250m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="300mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="300m">
        <label class="form__label" for="300mdistCuerpoAgua">
          300m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="350mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="350m">
        <label class="form__label" for="350mdistCuerpoAgua">
          350m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="400mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="400m">
        <label class="form__label" for="400mdistCuerpoAgua">
          400m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="450mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="450m">
        <label class="form__label" for="450mdistCuerpoAgua">
          450m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="500mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="500m">
        <label class="form__label" for="500mdistCuerpoAgua">
          500m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="550mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="550m">
        <label class="form__label" for="550mdistCuerpoAgua">
          550m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="600mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="600m">
        <label class="form__label" for="600mdistCuerpoAgua">
          600m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="650mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="650m">
        <label class="form__label" for="650mdistCuerpoAgua">
          650m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="700mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="700m">
        <label class="form__label" for="700mdistCuerpoAgua">
          700m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="750mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="750m">
        <label class="form__label" for="750mdistCuerpoAgua">
          750m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="800mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="800m">
        <label class="form__label" for="800mdistCuerpoAgua">
          800m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="850mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="850m">
        <label class="form__label" for="850mdistCuerpoAgua">
          850m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="900mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="900m">
        <label class="form__label" for="900mdistCuerpoAgua">
          900m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="950mdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="950m">
        <label class="form__label" for="950mdistCuerpoAgua">
          950m
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="1kdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="1km">
        <label class="form__label" for="1kdistCuerpoAgua">
          1km
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.distCuerpoAgua"
        id="mas1kdistCuerpoAgua"
        name="distCuerpoAgua"
        v-validate="'required'"
        value="Más de 1km">
        <label class="form__label" for="mas1kdistCuerpoAgua">
          Más de 1km
        </label>
      </div>
    </form-group>

    <form-group :error="errors.has('ver-huellas-depredador') && submitted">
      <label class="form__label form__label--required">
        55. ¿Logró ver las huellas del posible depredador?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.verHuellasDepredador"
        id="siverHuellasDepredador"
        name="ver-huellas-depredador"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="siverHuellasDepredador">Si</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.verHuellasDepredador"
        id="noverHuellasDepredador"
        name="ver-huellas-depredador"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="noverHuellasDepredador">
          No
        </label>
      </div>
      <form-group :error="errors.has('imagen-huellas') && submitted"
      v-if="form.verHuellasDepredador">
        <div class="identado" v-if="form.verHuellasDepredador">
          <label class="form__label form__label--required">
            ¿A cual de estas se parece?
          </label>
          <p class="text">
            OPCIONAL: Si el ganadero tiene registro fotográfico, pedírsela y adjuntarla en el bloque
            &quot;Adjuntos&quot;
          </p>
        </div>
        <div class="flex--container">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.huellasDepredador"
          id="1huellasDepredador"
          name="imagen-huellas"
          v-validate="'required'"
          value="1">
          <label class="form__label" for="1huellasDepredador">
            <img src="/huella-coyote.jpg" width="100%">
          </label>
        </div>
        <div class="flex--container">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.huellasDepredador"
          id="2huellasDepredador"
          name="imagen-huellas"
          v-validate="'required'"
          value="2">
          <label class="form__label" for="2huellasDepredador">
            <img src="/huella-jaguar.jpg" width="100%">
          </label>
        </div>
        <div class="flex--container">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.huellasDepredador"
          id="3huellasDepredador"
          name="imagen-huellas"
          v-validate="'required'"
          value="3">
          <label class="form__label" for="3huellasDepredador">
            <img src="/huella-puma.jpg" width="100%">
          </label>
        </div>
        <div class="flex--container">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.huellasDepredador"
          id="4huellasDepredador"
          name="imagen-huellas"
          v-validate="'required'"
          value="4">
          <label class="form__label" for="4huellasDepredador">
            <img src="/huella-ocelote.jpg" width="100%">
          </label>
        </div>
      </form-group>
    </form-group>

  </form>
</template>

<script>
export default {
  name: "FormGanadoBloque5",
  data() {
    return {
      deshabilitarPartes: false,
    };
  },
  props: {
    editando: Boolean,
    submitted: Boolean,
    form: Object,
  },
  methods: {
    validar,
    onAnimalPartesTodoCheck,
  },
  mounted() {
    if (this.form.resultadoAnimalAtacadoPartes.includes("Todo")) {
      this.deshabilitarPartes = true;
    }
  },
};

function validar() {
  return this.$validator.validate();
}

function onAnimalPartesTodoCheck() {
  const todoSeleccionado = this.form.resultadoAnimalAtacadoPartes.includes("Todo");
  if (todoSeleccionado) {
    this.form.resultadoAnimalAtacadoPartes = ["Todo"];
    this.deshabilitarPartes = true;
  } else {
    this.deshabilitarPartes = false;
  }
}
</script>

<style lang="scss">
.contenedor-partes-vaca {
  display: flex;
  div {
    margin-right: .5em;
  }
}
</style>
